import Storage from "./Storage";

class ConfigStorage extends Storage {
  get getConfig() {
    return this.value && this.value.config;
  }
}

export default new ConfigStorage("CONFIG");
